import { stringEmpty } from './display'
import { WebCrypto } from './WebCrypto'

export const getAuthorizationHelpers = async (sharedSecret, { crypto: _crypto, util: _util } = {}) => {
  if (stringEmpty(sharedSecret)) {
    return undefined
  }

  const webCrypto = new WebCrypto({ crypto: _crypto, util: _util })
  const sharedKey = await webCrypto.restoreStorableKey(
    'sharedSecret',
    sharedSecret
  )

  return {
    encrypt: async (decryptedMessage) => (
      webCrypto.encryptMessage(decryptedMessage, sharedKey)
    ),
    decrypt: async (encryptedMessage) => (
      webCrypto.decryptMessage(encryptedMessage, sharedKey)
    ),
  }
}
